import { AxiosResponse } from "axios";
import { IGetResponse, IListResponse } from "../../../models/Api";
import {
  CreateQuoteOpts,
  Quote,
  SearchableQuotesFilterInput,
  UpdateQuoteOpts,
} from "../../../models/Api/Quotes";
import { axiosInstance } from "../../../../../axiosInstance";

export const listQuotes = async (
  buildingId: string,
  offset: number,
  limit: number,
  filter?: SearchableQuotesFilterInput
): Promise<AxiosResponse<IListResponse<Quote>>> => {
  const params = {
    offset,
    limit,
  };

  if (filter) {
    const keys = Object.keys(filter);
    keys.forEach(key => {
      const operator = Object.keys(filter[key]);
      if (operator) {
        const value = filter[key][operator];
        if (operator.includes("between")) {
          value.forEach((val: string, index: number) => {
            params[`${key}[${operator}][${index}]`] = val;
          });
        } else {
          if (value !== null && value !== "" && value !== undefined) {
            params[`${key}[${operator}]`] = value;
          }
        }
      }
    });
  }

  return axiosInstance.get(`/quotes/buildings/${buildingId}`, {
    params,
  });
};

export const createQuote = async (
  payload: CreateQuoteOpts
): Promise<AxiosResponse<IGetResponse<Quote>>> => {
  return axiosInstance.post(`/quotes`, payload);
};

export const getQuote = async (
  id: string
): Promise<AxiosResponse<IGetResponse<Quote>>> => {
  return axiosInstance.get(`/quotes/${id}`);
};

export const updateQuote = async ({
  id,
  ...payload
}: UpdateQuoteOpts): Promise<AxiosResponse<IGetResponse<Quote>>> => {
  return axiosInstance.put(`/quotes/${id}`, payload);
};

export const downloadPdf = async (
  id: number
): Promise<AxiosResponse<Buffer>> => {
  return axiosInstance.get(`/quotes/${id}/pdf_url`, { responseType: "blob" });
};

interface Cart {
  id: string;
}

export const convertToOrder = async (
  id: number
): Promise<AxiosResponse<IGetResponse<Cart>>> => {
  return axiosInstance.post(`/quotes/${id}/order`);
};
